module.exports = __webpack_public_path__ + "img/shop-amazon.a7a8133d.png";